import { FC } from "react";
import Text from "../Text";

import styles from "./styles.module.scss";

type SwitchProps = {
    checked: boolean;
    label?: string;
    onChange: (checked: boolean) => void;
    colors?: { on: string; off: string; thumb: string };
    className?: string;
    ariaLabel?: string;
};

const Switch: FC<SwitchProps> = ({
    checked,
    label,
    onChange,
    colors,
    className,
    ariaLabel,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.checked);
    };

    return (
        <div className={`${styles.container} ${className || ""}`}>
            <label
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                }}
            >
                <input
                    type="checkbox"
                    style={{ display: "none" }}
                    checked={checked}
                    onChange={handleChange}
                    aria-label={ariaLabel || label || "Activer ou désactiver"}
                />
                <span
                    style={{
                        width: 28,
                        height: 18,
                        background: checked
                            ? colors?.on || "#243267"
                            : colors?.off || "#ccc",
                        borderRadius: 29,
                        transition: "background 0.3s",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 2px",
                        position: "relative",
                    }}
                >
                    <span
                        style={{
                            width: 14,
                            height: 14,
                            background: colors?.thumb || "#fff",
                            borderRadius: "50%",
                            transition: "transform 0.3s",
                            transform: checked
                                ? "translateX(14px)"
                                : "translateX(0)",
                        }}
                    />
                </span>
            </label>
            <Text variant="body-bold">{label}</Text>
        </div>
    );
};

export default Switch;
